import * as userSettings from '@/store/accounts/usersSettings.helpers'
import * as mapUtils from '@/maps/google/mapUtils'
import * as googleMaps from '@/common/googleMaps'

export default {}

const template =
  `<span class="fa-stack fa-2x">
    <i class="fas fa-map-marker fa-stack-2x {{ color }}" data-fa-transform="shrink-3 down-2"></i>
    <i class="fas {{ icon }} fa-stack-1x color-grey-50" data-fa-transform="shrink-4"></i>
  </span>`

export const alarm = template.replace('{{ icon }}', 'fa-bell-exclamation')
  .replace('{{ color }}', 'color-red-800')

export const speeding = template.replace('{{ icon }}', 'fa-tachometer-alt-fastest')
  .replace('{{ color }}', 'color-orange-800')

export const batteryLow = template.replace('{{ icon }}', 'fa-battery-quarter')
  .replace('{{ color }}', 'color-orange-800')

export const batteryDisconnected = template.replace('{{ icon }}', 'fa-battery-slash')
  .replace('{{ color }}', 'color-red-800')

export const accident = template.replace('{{ icon }}', 'fa-car-crash')
  .replace('{{ color }}', 'color-red-800')

export const harshDriving = template.replace('{{ icon }}', 'fa-car-tilt')
  .replace('{{ color }}', 'color-orange-800')

export const engineWarning = template.replace('{{ icon }}', 'fa-engine-warning')
  .replace('{{ color }}', 'color-orange-800')

export const alarmExclamation = template.replace('{{ icon }}', 'fa-exclamation')
  .replace('{{ color }}', 'color-red-800')

export const warningExclamation = template.replace('{{ icon }}', 'fa-exclamation')
  .replace('{{ color }}', 'color-orange-800')

export const information = template.replace('{{ icon }}', 'fa-info')
  .replace('{{ color }}', 'color-green-800')

export const temperatureLow = template.replace('{{ icon }}', 'fa-temperature-low')
  .replace('{{ color }}', 'color-orange-800')

export const temperatureHigh = template.replace('{{ icon }}', 'fa-temperature-high')
  .replace('{{ color }}', 'color-orange-800')

export const locationSlash = template.replace('{{ icon }}', 'fa-location-slash')
  .replace('{{ color }}', 'color-orange-800')

export const ptoOn = template.replace('{{ icon }}', 'fa-truck-loading')
  .replace('{{ color }}', 'color-orange-800')

export const ptoOff = template.replace('{{ icon }}', 'fa-truck-loading')
  .replace('{{ color }}', 'color-green-800')

const eventMarkers = {
  'PANIC': { icon: alarm, type: 'alarm', option: 'event_show_alarms' },
  'PANIC:EMERGENCY': { icon: alarm, type: 'alarm', option: 'event_show_alarms' },
  'JAMMING': { icon: alarm, type: 'alarm', option: 'event_show_alarms' },
  'JAMMING:START': { icon: alarm, type: 'alarm', option: 'event_show_alarms' },
  'ALARM:MOVEMENT:NONE': { icon: alarm, type: 'alarm', option: 'event_show_alarms' },
  'ALARM:HARDWARE:FAULT': { icon: alarm, type: 'alarm', option: 'event_show_alarms' },
  'LIMP_MODE:ACTIVE': { icon: alarm, type: 'alarm', option: 'event_show_alarms' },
  'SPEEDING': { icon: speeding, type: 'warning', option: 'event_show_speeding' },
  'SPEEDING:START:ZONE': { icon: speeding, type: 'warning', option: 'event_show_speeding' },
  'BATTERY:DISCONNECTED': { icon: batteryDisconnected, type: 'alarm', option: 'event_show_battery_disconnect' },
  'BATTERY:LOW': { icon: batteryLow, type: 'warning', option: 'event_show_battery_low' },
  'BATTERY:ABNORMAL:EXT': { icon: batteryLow, type: 'warning', option: 'event_show_battery_low' },
  'BATTERY:ABNORMAL:INT': { icon: batteryLow, type: 'warning', option: 'event_show_battery_low' },
  'BATTERY:DISCHARGING:INT': { icon: batteryLow, type: 'warning', option: 'event_show_battery_low' },
  'COLLISION': { icon: accident, type: 'alarm', option: 'event_show_accidents' },
  'COLLISION:DETECTED': { icon: accident, type: 'alarm', option: 'event_show_accidents' },
  'COLLISION:LIMITED_NOCALIB': { icon: accident, type: 'alarm', option: 'event_show_accidents' },
  'COLLISION:LIMITED_CALIB': { icon: accident, type: 'alarm', option: 'event_show_accidents' },
  'COLLISION:FULL_NOCALIB': { icon: accident, type: 'alarm', option: 'event_show_accidents' },
  'COLLISION:FULL_CALIB': { icon: accident, type: 'alarm', option: 'event_show_accidents' },
  'COLLISION:NOCALIB': { icon: accident, type: 'alarm', option: 'event_show_accidents' },
  'COLLISION:FRONT': { icon: accident, type: 'alarm', option: 'event_show_accidents' },
  'COLLISION:REAR': { icon: accident, type: 'alarm', option: 'event_show_accidents' },
  'COLLISION:TURN_OVER': { icon: accident, type: 'alarm', option: 'event_show_accidents' },
  'HARSH:BRAKING': { icon: harshDriving, type: 'warning', option: 'event_show_harsh_driving' },
  'HARSH:ACCELERATION': { icon: harshDriving, type: 'warning', option: 'event_show_harsh_driving' },
  'HARSH:CORNERING': { icon: harshDriving, type: 'warning', option: 'event_show_harsh_driving' },
  'HARSH:DRIVING': { icon: harshDriving, type: 'warning', option: 'event_show_harsh_driving' },
  'ENGINE:RPM:HIGH': { icon: engineWarning, type: 'warning', option: 'event_show_engine_warning' },
  'ENGINE:TEMP:HIGH': { icon: engineWarning, type: 'warning', option: 'event_show_engine_warning' },
  'ENGINE:OIL:CHANGE': { icon: engineWarning, type: 'warning', option: 'event_show_engine_warning' },
  'TEMP:LOW': { icon: temperatureLow, type: 'warning', option: 'event_show_temperature_low' },
  'TEMP:HIGH': { icon: temperatureHigh, type: 'warning', option: 'event_show_temperature_high' },
  'GPS:FAULT': { icon: locationSlash, type: 'warning', option: 'event_show_gps_fault' },
  'PTO:ON': { icon: ptoOn, type: 'warning', option: 'event_show_pto_on_off' },
  'PTO:OFF': { icon: ptoOff, type: 'info', option: 'event_show_pto_on_off' }
}

export const getEventMarker = (event) => {
  if (eventMarkers.hasOwnProperty(event)) {
    return eventMarkers[event]
  } else {
    return null
  }
}

export const plotEventMarkers = (telemetry, markerClickCallback = null, maxIconCount = 25) => {
  // Get the options whether icons should be displayed or not
  let options = {
    'event_show_alarms': { show: userSettings.get('event_show_alarms', true), count: 0 },
    'event_show_accidents': { show: userSettings.get('event_show_accidents', true), count: 0 },
    'event_show_battery_disconnect': { show: userSettings.get('event_show_battery_disconnect', true), count: 0 },
    'event_show_battery_low': { show: userSettings.get('event_show_battery_low', true), count: 0 },
    'event_show_harsh_driving': { show: userSettings.get('event_show_harsh_driving', true), count: 0 },
    'event_show_speeding': { show: userSettings.get('event_show_speeding', true), count: 0 },
    'event_show_engine_warning': { show: userSettings.get('event_show_engine_warning', true), count: 0 },
    'event_show_temperature_low': { show: userSettings.get('event_show_temperature_low', true), count: 0 },
    'event_show_temperature_high': { show: userSettings.get('event_show_temperature_high', true), count: 0 },
    'event_show_gps_fault': { show: userSettings.get('event_show_gps_fault', true), count: 0 },
    'event_show_pto_on_off': { show: userSettings.get('event_show_pto_on_off', true), count: 0 }
  }

  let markers = []

  let tooManyIcons = false
  telemetry.forEach((position, positionIndex) => {
    let alarmCount = 0
    let warningCount = 0
    let infoCount = 0
    let eventCount = 0
    let eventMarker = null
    let lastEventMarker = null

    position.events.forEach(event => {
      eventMarker = getEventMarker(event[0])
      if (eventMarker !== null) {
        if (options[eventMarker.option].show) {
          if (options[eventMarker.option].count <= maxIconCount) {
            if (eventMarker.type === 'alarm') {
              alarmCount += 1
              eventCount += 1
              options[eventMarker.option].count += 1
              lastEventMarker = { ...eventMarker }
            } else if (eventMarker.type === 'warning') {
              warningCount += 1
              eventCount += 1
              options[eventMarker.option].count += 1
              lastEventMarker = { ...eventMarker }
            } else if (eventMarker.type === 'info') {
              infoCount += 1
              eventCount += 1
              options[eventMarker.option].count += 1
              lastEventMarker = { ...eventMarker }
            }
          }
        }

        if (options[eventMarker.option].count > maxIconCount && !tooManyIcons) {
          tooManyIcons = true
        }
      }
    })

    if (eventCount === 1) {
      console.log(`DEBUG: eventMarkers:plotEventMarkers: ${lastEventMarker.icon}`)
      markers.push(mapUtils.createCustomMarker(
        googleMaps.map,
        new google.maps.LatLng(position.gps.latitude, position.gps.longitude),
        lastEventMarker.icon, { positionIndex }, {}, markerClickCallback)
      )
    } else if (eventCount > 1) {
      // There are multiple events
      if (alarmCount > 0) {
        // We'll add a single "red" alarm icon
        markers.push(mapUtils.createCustomMarker(
          googleMaps.map,
          new google.maps.LatLng(position.gps.latitude, position.gps.longitude),
          alarmExclamation, { positionIndex }, {}, markerClickCallback)
        )
      } else if (warningCount > 0) {
        // We'll add a single "orange" warning icon
        markers.push(mapUtils.createCustomMarker(
          googleMaps.map,
          new google.maps.LatLng(position.gps.latitude, position.gps.longitude),
          warningExclamation, { positionIndex }, {}, markerClickCallback)
        )
      } else if (infoCount > 0) {
        // We'll add a single "green" info icon
        markers.push(mapUtils.createCustomMarker(
          googleMaps.map,
          new google.maps.LatLng(position.gps.latitude, position.gps.longitude),
          information, { positionIndex }, {}, markerClickCallback)
        )
      }
    }
  })

  return { markers, tooManyIcons }
}



// WEBPACK FOOTER //
// ./src/maps/google/eventMarkers.js